var React = require('react');

function TickInCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10 16.6667L15.2174 22L25 12","stroke":"#8A55FB","strokeWidth":"2","key":0}),React.createElement("circle",{"cx":"17.5","cy":"17.5","r":"16.5","stroke":"#8A55FB","strokeWidth":"2","key":1})]);
}

TickInCircle.defaultProps = {"width":"35","height":"35","viewBox":"0 0 35 35","fill":"none"};

module.exports = TickInCircle;

TickInCircle.default = TickInCircle;
